import React from 'react';
import MeasurementUnitBody from './body.tsx';
import MeasurementUnitHeader from './header.tsx';
import { useParams } from 'react-router-dom';
import { MeasurementUnitContextProvider } from '../../../../contexts/measurementUnits/measurementUnit.tsx';
import { Role } from '../../../../models/enums/role.ts';
import { AccessProvider } from '../../../../contexts/accessProvider.tsx';

const MeasurementUnit = () => {
    const { id } = useParams();
    return (
        <AccessProvider roles={[Role.superAdmin]}>
            <MeasurementUnitContextProvider id={id}>
                <MeasurementUnitHeader />
                <MeasurementUnitBody />
            </MeasurementUnitContextProvider>
        </AccessProvider>
    );
};

export default MeasurementUnit;
